import { DescriptionFieldProps } from '@rjsf/utils';
import { Templates } from '@rjsf/bootstrap-4';
import { MarkdownContent } from '../markdown-content';

export function DescriptionFieldTemplate({
  description,
  ...props
}: DescriptionFieldProps) {
  return (
    /* @ts-ignore */
    <Templates.DescriptionFieldTemplate
      {...props}
      description={<MarkdownContent>{description as string}</MarkdownContent>}
    />
  );
}
